import { SET_TOP_RTB_STATS, SET_TOP_RTB_FAIL_REASONS, SET_RTB_STATS, SET_RTB_FAIL_REASONS } from './mutationTypes';

import { setActionStatusPending, setActionStatusSuccess, setActionStatusError } from '@/store/helpers';
import { getBreakdownTableRecord } from './utils';


/** @type {import('vuex').MutationTree<typeof import('./state')>} */
export const mutations = {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [SET_TOP_RTB_STATS](state, records) {
    if (records?.data?.top?.affiliate) {
      state.affiliatesStats = records?.data?.top?.affiliate;
    } else {
      state.affiliatesStats = records;
    }
  },
  [SET_TOP_RTB_FAIL_REASONS](state, records) {
    if (records?.data?.top?.affiliate) {
      state.affiliatesErrors = records?.data?.top?.affiliate;
    } else {
      state.affiliatesErrors = records;
    }
  },
  [SET_RTB_STATS](state, affiliates) {
    state.affiliatesStats = Array.from(affiliates.values, getBreakdownTableRecord);
  },
  [SET_RTB_FAIL_REASONS](state, affiliates) {
    state.affiliatesErrors = Array.from(affiliates.values, getBreakdownTableRecord);
  },
};